export function scrollToContacto() {
  document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
}
